module.exports = __webpack_public_path__ + "img/droplet-degree.d8c56ac8.svg";